

















































import Vue, { PropType } from 'vue';
import BasePage from '@/components/BasePage.vue';

export default Vue.extend({
  name: 'EntityPage',
  props: {
    title: String,
    image: String,
    tab: (null as unknown) as PropType<number | null>,
    loading: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    onTabChange(val: number) {
      this.$emit('tab-change', val);
    },
    goBack() {
      this.$router.back();
    },
  },
  computed: {
    toolbarTop() {
      return this.$vuetify.breakpoint.smAndDown ? 56 : 64;
    },
  },
  components: {
    BasePage,
  },
});
